import React from 'react';

const ChevronUpBold = () => (
    <svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M14.3893 11.6107L17 9L8.51518 0.515178L5.90446 3.12589L5.90505 3.12648L0.030323 9.00121L2.64104 11.6119L8.51577 5.7372L14.3893 11.6107Z" fill="#111111"/>
    </svg>
);

export default ChevronUpBold;
